/**
 * A mapping of method name to method name.
 * @type {Object}
 */
const API_METHOD = {
  GET: 'get',
  POST: 'post',
  PUT: 'put',
  DEL: 'del'
}

// const TRAINING_JWT_DEV_PRODUCTION = DEVELOPMENT ? 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOjM3NzczLCJlbWFpbCI6ImJlY2hldC5qYW1lc0BnbWFpbC5jb20iLCJwcm9maWxlSWQiOjM3NDI1LCJpYXQiOjE2NjA1NzUxODksImV4cCI6MTY2MzI1MzU4OSwiaXNzIjoiZ3ltYWhvbGljIiwic3ViIjoiYmVjaGV0LmphbWVzQGdtYWlsLmNvbSJ9.CZRwG2kLvHfBVSC0hvwWQBeIRoBfDbkqXGyCPVE0zDg' : null
const TRAINING_JWT_DEV_PRODUCTION = DEVELOPMENT ? null : null
export {
  API_METHOD,
  TRAINING_JWT_DEV_PRODUCTION
}
